export default {
	damage: 'Seller has not uploaded any damage photos',
	documents: 'Seller has not uploaded any document photos',
	other: 'Seller has not uploaded any photos',
	tyres: 'Seller has not uploaded any tyre photos',
	vehicle: 'Seller has not uploaded any vehicle photos',
	wheels: 'Seller has not uploaded any wheel photos',
};
